<!-- 创青春 -->
<template>
  <div class="sponsor">
    <v-head></v-head>
    <div class="container" style="min-width:1200px;">
      <!-- banner -->
      <div class="sponsor-banner">
        <el-carousel trigger="click" :interval="5000" arrow="never" height="100%">
          <el-carousel-item v-for="(item,index) in bannerList" :key="index">
            <div class="banner-img" :style="'background-image:url(' + item.image_url + ')'"></div>
            <div class="help-banner-zz3"></div>
            <div class="sponsor-banner-con">
              <div class="sponsor-banner-title">{{ item.title }}</div>
              <div class="sponsor-banner-line">—</div>
              <div class="sponsor-banner-message">{{ item.description }}</div>
              <div class="sponsor-banner-more">
                <a href="javascript:void(0);">
                  <el-button size="small">
                    {{ item.button_name }}
                    <i class="el-icon-arrow-right"></i>
                  </el-button>
                </a>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <!-- 活动展示 -->
      <div class="sponsor-activity">
        <!-- 活动切换nav -->
        <el-tabs class="sponsor-activity-nav" v-model="activityed" type="border-card">
          <el-tab-pane
            v-for="(item,index) of activityList"
            :key="index"
            :label="item.label"
            :name="item.label"
          >
            <div class="sponsor-activity-con sponsor-chuangqingchun-con">
              <div class="activity-con-title">{{ item.label }}</div>
              <div class="activity-con-message" v-html="item.message"></div>
              <div class="activity-con-cut">
                <div
                  class="activity-cut-prev"
                  :class="activityed === activityList[0].label?'activity-disabled':''"
                  @click="prev()"
                >
                  <i class="el-icon-arrow-left"></i>
                </div>
                <div
                  class="activity-cut-next"
                  :class="activityed === activityList[activityList.length-1].label?'activity-disabled':''"
                  @click="next()"
                >
                  <i class="el-icon-arrow-right"></i>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <!-- 相关报道 -->
      <div class="sponsor-case">
        <div class="case-title">
          <span class="case-title-t">相关报道</span>
          <span class="case-title-b"></span>
        </div>
        <div class="case-main">
          <div class="report-banner">
            <div class="swiper-container swiper-report" id="swiper-report">
              <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(item,index) of reportList" :key="index">
                  <div class="case-msg-img" :style="'background-image:url(' + item.url + ')'">
                    <div class="case-msg-zz"></div>
                  </div>
                  <div class="case-messagebox">
                    <div class="case-message-top">
                      <div class="case-msg-title">{{ item.title }}</div>
                      <div class="caseTitle">{{ item.caseTitle }}</div>
                      <div class="caseContent">{{ item.content }}</div>
                    </div>
                    <div class="case-message-bottom">
                      <span class="toSeemore">查看详情</span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 如果需要导航按钮 -->
              <div class="arrow-box">
                <div class="el-icon-arrow-left arrow-left"></div>
                <div class="el-icon-arrow-right arrow-right"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 报名通道 -->
      <div class="sponsor-case registrationChannel">
        <div class="regc-layout"></div>
        <div class="case-title">
          <span class="case-title-t">报名通道</span>
          <span class="case-title-b"></span>
        </div>
        <div class="case-main regc-main">
          <div class="registrationChannel-banner">
            <div class="swiper-container swiper-regc" id="swiper-regc">
              <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(item,index) of regcList" :key="index">
                  <div class="regc-messagebox">
                    <div class="regc-message-top">
                      <div class="regc-msg-title">{{ item.name }}</div>
                      <span class="regc-title-line"></span>
                      <div
                        class="regcContent"
                        v-for="(item,index) of item.content"
                        :key="index"
                      >{{ item }}</div>
                      <div class="regcContent-url" v-if="item.url &&item.url != ''">{{item.url}}</div>
                    </div>
                    <div class="regc-message-bottom">
                      <span class="downloadrun" v-if="item.status == 1">
                        <span class="download-btn">下载报名资料</span>
                      </span>
                      <div class="scanrun" v-else-if="item.status == 2">
                        <span class="ercode-box"></span>
                        <span class="ercode-box"></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 奖项设置 -->
      <div class="sponsor-case awards-case">
        <div class="case-title">
          <span class="case-title-t">奖项设置</span>
          <span class="case-title-b"></span>
        </div>
        <div class="case-main awards-main">
          <div class="awards-item">
            <span class="awards-item-logo awards-item-logo1"></span>
            <span class="awards-item-title">奖金+政策34.6万</span>
            <span class="awards-item-intr">金奖：1万/名 银奖：5千/名 铜奖：1千/名</span>
            <span class="awards-item-intr">区域赛优秀组织奖10名</span>
          </div>
          <div class="awards-item">
            <span class="awards-item-logo awards-item-logo2"></span>
            <span class="awards-item-title">奖项设置</span>
            <span class="awards-item-intr">金奖10名，银奖34名，铜奖76名</span>
            <span class="awards-item-intr">奖励方式：证书+奖金</span>
          </div>
          <div class="awards-item">
            <span class="awards-item-logo awards-item-logo3"></span>
            <span class="awards-item-title">专项奖功7名</span>
            <span class="awards-item-intr">优胜奖、优秀创业标兵、最具价值投资奖、杰出贡献奖、最佳解决方</span>
            <span class="awards-item-intr">案奖、品牌影响力大奖、优秀创业就业实践基地奖</span>
          </div>
        </div>
      </div>
      <!-- 参赛须知 -->
      <div class="contest-date">
        <div class="contest-title">参赛须知</div>
        <div class="contest-time">报名时间：2020年4月15日12时 至 2020年6月30日24时</div>
        <div class="contest-info">
          <span
            class="contest-info-line"
          >注意事项：需通过电子邮件提交报名相关资料，发送成功将收到反馈邮件；报名方式以上任选其一，切勿重复报名，重复报名严重者取消参选资格；</span>
          <span class="contest-info-line">所有报名邮件附件需在报名期间长期有效保证可下载；切勿通过其他官方渠道进行报名，如发现违法行为欢迎向组委会邮件举报。</span>
        </div>
        <div class="contest-button">
          <span class="contest-button-item">阅读参赛须知</span>
          <span class="contest-button-item">下载报名资料</span>
        </div>
      </div>
    </div>
    <v-footer></v-footer>
  </div>
</template>
<script>
import vHead from '@/components/header/header.vue'
import vFooter from '@/components/footer/footer.vue'
import Swiper from 'swiper'
import {
  Carousel,
  CarouselItem,
  Button,
  Tabs,
  TabPane,
  Input
} from 'element-ui'
export default {
  components: {
    'el-carousel': Carousel,
    'el-carousel-item': CarouselItem,
    'v-head': vHead,
    'v-footer': vFooter,
    'el-button': Button,
    'el-tabs': Tabs,
    'el-tab-pane': TabPane,
    'el-input': Input
  },
  data () {
    return {
      activityed: '赛事简介',
      activityList: [{
        label: '赛事简介',
        message: '2013年11月8日，习近平总书记向2013年全球创业周中国站活动组委会专门致贺信，特别强调了青年学生在创新创业中的重要作用，并指出全社会都应当重视和支持青年创新创业。党的十八届三中全会对“健全促进就业创业体制机制”作出了专门部署，指出了明确方向。为贯彻落实习近平总书记系列重要讲话和党中央有关指示精神，适应大学生创业发展的形势需要，共青团中央、教育部、人力资源和社会保障部、中国科协、全国学联决定，在原有“挑战杯”中国大学生创业计划竞赛的基础上，自2014年起共同组织开展“创青春”全国大学生创业大赛，每两年举办一次。<br>以党的十八大和十八届二中、三中全会精神为指导，以“中国梦，创业梦，我的梦”为主题，以增强大学生创新、创意、创造、创业的意识和能力为重点，以深化大学生创业实践为导向，着力打造权威性高、影响面广、带动力大的全国大学生创业大赛。<br>以此为带动，将大学生的创业梦与中国梦有机结合，打造深入持久开展“我的中国梦”主题教育实践活动的有效载体；将激发创业与促进就业有机结合，打造整合资源服务大学生创业就业的工作体系和特色阵地；将创业引导与立德树人有机结合，打造增强大学生社会责任感、创新精神、实践能力的有形工作平台。'
      }, {
        label: '共青城市',
        message: '共青城市，简称共青，为江西省县级市，由江西省直管，九江市代管。<br>共青城市位于江西省北部、九江市南部，鄱阳湖之滨、庐山南麓，是昌九一体化重要战略支点城市，是江西省改革创新先行、先试区，是国家级新区（赣江新区）四大组团之一。<br>共青城其前身是1955年上海青年志愿者创建的共青社，2010年设立共青城市，是全国唯一以共青团命名的城市。<br>共青城是全国青年创业基地、全国青少年教育基地、国家级生态示范区、中国羽绒服装名城、国家生态文明教育基地、国家级纺织服装产业集群基地、中国绿色名区。<br>2020年4月27日，国务院同意在九江市设立跨境电子商务综合试验区。'
      }, {
        label: '互联网组',
        message: '大赛旨在国家重点发展文化科技融合、产教融合等战略政策背景下，围绕数字经济产业创新发展需求，通过线上和线下相融合的形式，由第二课堂“到梦空间”平台携手行业企业共同命题，征集、培育、孵化一批数字创意、互联网营销、新媒体运营等领域的优秀创新创业项目，实现推动产业升级、促进创业就业和服务区域经济发展等目标。<br>命题包括以下三个方面：<br>数字创意：按要求创作短视频、动漫、文创作品等；<br>互联网营销：按要求对特定产品进行互联网营销等；<br>新媒体运营：按要求创作文案、媒体宣发、内容传播等。'
      }, {
        label: '赛程安排',
        message: ''
      }],
      bannerList: [{
        button_name: '了解更多',
        description: '创青春是“创青春”全国大学生创业大赛的简称，是“挑战杯”中国大学生创业计划竞赛的改革提升。以党的十八大和十八届二中、三中全会精神为指导，以“中国梦，创业梦，我的梦”为主题，以增强大学生创新、创意、创造、创业的意识和能力为重点，以深化大学生创业实践为导向，着力打造权威性高、影响面广、带动力大的全国大学生创业大赛。',
        id: 29,
        image_url: 'https://sponsorentpic.nauac.com/20200522/78a026204c85401d8c0bf2c6e45825b4.jpg',
        title: '关于创青春',
        url: 'https://sponsorentpic.nauac.com/20200522/78a026204c85401d8c0bf2c6e45825b4.jpg'
      }],
      reportList: [{
        url: 'https://sponsorentpic.nauac.com/20200527/c9324175ffec45398da65bbf8d31c998.jpg',
        title: '2016年“创青春”全国大学生创业大赛第一次新闻发布会在京召开',
        caseTitle: '组委会 发表于 2016.07.04',
        content: '4月29日上午，2016年“创青春”全国大学生创业大赛第一次新闻发布会暨网络访谈在北京团中央网络影视中心国际会议厅召开。据介绍，本次大赛将采用“一校两城、校地联动”的办赛模式。'
      }, {
        url: 'https://sponsorentpic.nauac.com/20200527/b38fe50bd60d4a0a9a8066467e909856.jpg',
        title: '2018年“创青春”全国大学生创业大赛终审决赛闭幕',
        caseTitle: '组委会 发表于 2018.11.06',
        content: '11月3日，由共青团中央、教育部、人力资源和社会保障部、中国科协、全国学联、浙江省人民政府主办，浙江大学、共青团浙江省委承办的2018年“创青春”浙大双创杯全国大学生创业大赛终审决赛在浙江大学落下帷幕。'
      }, {
        url: 'https://sponsorentpic.nauac.com/20200527/78c6483bf9764f16a6d771b9863f8e88.jpg',
        title: '2018年“创青春”全国大学生创业大赛专项赛在金华开赛',
        caseTitle: '组委会 发表于 2018.07.16',
        content: '7月13日，2018年“创青春”全国大学生创业大赛MBA专项赛和网络信息经济专项赛在浙江金华拉开帷幕。'
      }, {
        url: 'https://sponsorentpic.nauac.com/20200527/aaa82f605b684bf8bab71a38120d0ad0.jpg',
        title: '2016年“创青春”中航工业全国大学生创业大赛创业计划赛和创业实践挑战赛复赛举行',
        caseTitle: '组委会 发表于 2016.08.21',
        content: '8月13日，2016年“创青春”中航工业全国大学生创业大赛创业暨第十届“挑战杯”中国大学生创业计划竞赛和创业实践挑战赛复赛在四川成都举行。'
      }, {
        url: 'https://sponsorentpic.nauac.com/20200527/19cfd6be294b4fff9cb0f7b29b0e22e2.jpg',
        title: '海内外知名高校学子相聚浙大，“创青春”国际名校邀请赛举办！',
        caseTitle: '组委会 发表于 2018.10.22',
        content: '10月18日至21日，2018年“创青春”浙大双创杯全国大学创业大赛国际名校邀请赛在浙江大学举行，来自10余个国内外知名高校在内的38支参赛团队参与此次比赛。'
      }, {
        url: 'https://sponsorentpic.nauac.com/20200527/9d939ac0c93245c8b286d7496065b566.jpg',
        title: '是怎样一场大赛，竟吸引这么多媒体的目光！',
        caseTitle: '组委会 发表于 2018.11.06',
        content: '本届“创青春”浙大双创杯全国大学生创业大赛终审决赛由共青团中央、教育部、人力资源和社会保障部、中国科协、全国学联、浙江省人民政府主办，浙江大学、共青团浙江省委承办。'
      }, {
        url: 'https://sponsorentpic.nauac.com/20200527/21311b70f04a4b4cbc8b99e3cfa379c3.jpg',
        title: '2014年“创青春”全国大学生创业大赛获奖名单',
        caseTitle: '中国青年网 发表于 2014.11.06',
        content: '经过网上书面评审、决赛现场答辩，现将2014年“创青春”全国大学生创业大赛高校团体奖名单、金奖项目名单、省级优秀组织奖名单予以公布。'
      }, {
        url: 'https://sponsorentpic.nauac.com/20200527/2e20909b7d344694afa3b8ebe7278342.jpg',
        title: '“创青春”全国大学生创业大赛吉祥物亮相开幕式',
        caseTitle: '组委会 发表于 2014.11.05',
        content: '自3月25日起，“创青春”大赛组委会面向全国征集2014年“创青春”全国大学生创业大赛吉祥物“创创”，“创创”取名源自“创青春”大赛中创业的主题，传达出“创新、创意、创造、创业、创青春”的赛事内涵。'
      }, {
        url: 'https://sponsorentpic.nauac.com/20200527/ec1cf31aa7ab40e3bb0dd52de87d4007.jpg',
        title: '2014“创青春”大赛金奖项目介绍（一）',
        caseTitle: '组委会 发表于 2014.11.07',
        content: '武汉鸣鸾信息科技有限公司成立于2011年。公司主要从事求职服务平台的开发与运营，核心产品为“海投网”。'
      }, {
        url: 'https://sponsorentpic.nauac.com/20200527/fb02aa35a853495781ddc055ecaf5ed1.jpg',
        title: '2014年“创青春”全国大学生创业大赛终审决赛闭幕',
        caseTitle: '组委会 发表于 2014.11.05',
        content: '11月4日，由共青团中央、教育部、人力资源和社会保障部、中国科协、全国学联、湖北省人民政府主办，工业和信息化部、国务院国有资产监督管理委员会等承办的2014年“创青春”全国大学生创业大赛终审决赛在华中科技大学落下帷幕。'
      }],
      regcList: [{
        name: '推荐报名',
        content: ['活动接受个人和平台机构的推荐报名', '由推荐人或推荐平台下载推荐表', '推荐承诺书', '填写并发送至'],
        url: 'tpgjwzb@163.com',
        status: 1
      }, {
        name: '官网报名',
        content: ['阅读参选须知，下载报名表、自荐承诺书', '填写并发送至组委会邮箱'],
        url: 'tpgjwzb@163.com',
        status: 1
      }, {
        name: '微信报名',
        content: ['扫描关注“中国青年网”', '“青春浙江”微信公众号', '回复“脱贫攻坚网络主播”参与活动'],
        url: '',
        status: 2
      }, {
        name: '合作平台报名',
        content: ['关注以下任一账号，按引导报名', '“青耘助农”快手关注入口', '“青耘助农”抖音关注入口'],
        url: '',
        status: 2
      }]
    }
  },
  created () {
    // 移动端适配最小高度为浏览器高度
    this.$nextTick(() => {
      let containerDom = document.getElementsByClassName('container')[0]
      if (containerDom) {
        containerDom.style.minHeight = (document.documentElement.clientHeight - 100) + 'px'
      }
    })
  },
  mounted () {
    this.$nextTick(() => {
      // eslint-disable-next-line
      var mySwiper = new Swiper('.swiper-report', {
        watchSlidesProgress: true,
        observer: true,
        observeParents: true,
        loop: true,
        speed: 500,
        initialSlide: 0,
        effect: 'coverflow',
        centeredSlides: true,
        slidesPerView: 'auto',
        coverflowEffect: {
          rotate: 0,
          stretch: 830,
          depth: 150,
          modifier: 1,
          slideShadows: true
        },
        navigation: {
          nextEl: '.arrow-left',
          prevEl: '.arrow-right'
        },
        on: {
          progress: function () {
            for (let i = 0; i < this.slides.length; i++) {
              const slide = this.slides.eq(i) // 指定匹配元素集缩减值
              const slideProgress = this.slides[i].progress // 当前元素集的progress值
              let modify = 0 // 偏移权重
              if (parseInt(Math.abs(slideProgress)) > 0) {
                modify = Math.abs(slideProgress) * 0.1 // 不一定要0.2，可自行调整
              }
              const translate = slideProgress * modify * 1000 + 'px' // 500是swiper-slide的宽度
              // const translate = 200 + 'px' // 500是swiper-slide的宽度
              const scale = 1 - Math.abs(slideProgress) / 1 // 缩放权重值，随着progress由中向两边依次递减，可自行调整
              const rotate = 0
              const zIndex = 99 - Math.abs(Math.round(10 * slideProgress))
              slide.transform(`translateX(${translate}) scale(${scale}) rotate(${rotate})`)
              slide.css('zIndex', zIndex)
              slide.css('opacity', 1) // 是否可见
              if (parseInt(slideProgress) > 1) { // 设置了只有选中的元素以及他两遍的显示，其他隐藏
                slide.css('opacity', 1)
              }
            }
          },
          setTransition: function (transition) {
            for (var i = 0; i < this.slides.length; i++) {
              var slide = this.slides.eq(i)
              slide.transition(transition)
            }
          }
        }
      })
      // 底下轮播图
      // eslint-disable-next-line
      var mySwiperRegc = new Swiper('.swiper-regc', {
        watchSlidesProgress: true,
        // observer: true,
        observeParents: true,
        loop: true,
        speed: 300,
        initialSlide: 0,
        spaceBetween: -20,
        centeredSlides: false,
        slidesPerView: 4,
        effect: 'coverflow',
        coverflowEffect: {
          rotate: 0,
          stretch: -5,
          depth: 15,
          modifier: 10,
          slideShadows: false
        },
        slidesPerGroup: 1
      })
    })
  },
  methods: {
    prev () {
      for (let i = 0; i < this.activityList.length; i++) {
        if (this.activityList[i].label === this.activityed) {
          if (i === 0) {
            return
          } else {
            this.activityed = this.activityList[i - 1].label
            return
          }
        }
      }
    },
    next (e) {
      for (let i = 0; i < this.activityList.length; i++) {
        if (this.activityList[i].label === this.activityed) {
          if (i === (this.activityList.length - 1)) {
            return
          } else {
            this.activityed = this.activityList[i + 1].label
            return
          }
        }
      }
    }
  }
}
</script>
<style src='../activity/activity_active.scss' lang="scss"></style>
<style src='../activity/activity.scss' lang="scss" scoped></style>
<style lang="scss" scoped>
.container .sponsor-chuangqingchun-con {
  height: auto !important;
  padding-bottom: 45px !important;
}
#swiper-report {
  width: 100%;
  padding-top: 10px;
  padding-bottom: 50px;
  .arrow-box {
    position: absolute;
    z-index: 50;
    bottom: 85px;
    right: 160px;
    display: flex;
    flex-direction: column;
    cursor: none;
    .el-icon-arrow-left {
      width: 20px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      background: #000000;
      color: #ffffff;
      font-size: 16px;
      margin-bottom: 10px;
      cursor: pointer;
    }
    .el-icon-arrow-right {
      width: 20px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      font-size: 16px;
      background: #000000;
      color: #ffffff;
      cursor: pointer;
    }
  }
}
#swiper-report .swiper-slide {
  background-position: center;
  background-size: cover;
  width: 930px;
  height: 280px;
  visibility: hidden;
  background-color: #ffffff;
  transition: all 0.4s ease;
  .case-msg-img {
    height: 100%;
    width: 45%;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
    position: absolute;
    left: 0;
    top: 0;
    border-radius: 10px;
    box-shadow: 0 0 6px 0px #f1f1f1;
  }
  .case-messagebox {
    position: absolute;
    width: 55%;
    top: 0;
    right: 0;
    height: 100%;
    padding: 35px 40px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    .case-message-top {
      .case-msg-title {
        font-size: 18px;
        color: #000000;
        font-weight: 700;
        line-height: 32px;
      }
      .caseTitle {
        color: #000000;
        line-height: 26px;
        margin-bottom: 5px;
      }
      .caseContent {
        line-height: 20px;
        padding-right: 80px;
        box-sizing: border-box;
        font-size: 12px;
      }
    }
    .case-message-bottom {
      .toSeemore {
        width: 110px;
        padding: 10px 0;
        display: inline-block;
        text-align: center;
        background: rgb(40, 115, 255);
        font-size: 14px;
        cursor: pointer;
        color: #ffffff;
      }
    }
  }
}

#swiper-report .swiper-slide.swiper-slide-prev,
#swiper-report .swiper-slide.swiper-slide-next,
#swiper-report .swiper-slide.swiper-slide-active {
  visibility: visible;
}
.registrationChannel {
  width: 100%;
  height: 100%;
  background-image: url("../../assets/img/banner2.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  position: relative;
  .regc-main {
    padding-bottom: 140px !important;
  }
  .registrationChannel-banner {
    // width: 100%;
    // height: 290px;
    width: 100%;
    height: 290px;
    margin: 0 auto;
  }
  .regc-layout {
    position: absolute;
    background-color: rgba(51, 51, 51, 0.8);
    color: rgba(51, 51, 51, 1);
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 0;
  }
  .case-title {
    z-index: 1;
    color: #ffffff;
    .case-title-t {
      color: #ffffff !important;
    }
  }
  .swiper-regc {
    width: 100%;
    height: 100%;
    .swiper-slide {
      text-align: center;
      font-size: 12px;
      background: #fff;
      display: flex;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      -webkit-justify-content: center;
      justify-content: center;
      -webkit-box-align: center;
      -ms-flex-align: center;
      -webkit-align-items: center;
      align-items: center;
      background-color: #cfcfcf;
    }
    .swiper-slide.swiper-slide-active {
      margin-left: -35px !important;
    }
    .swiper-slide.swiper-slide-next {
      background-color: #fff;
      margin-left: 35px !important;
    }
    .swiper-slide.swiper-slide-next + div.swiper-slide {
      background-color: #fff;
      margin-right: 15px !important;
    }
  }
  .regc-messagebox {
    width: 100%;
    height: 100%;
    padding: 30px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    .regc-message-top {
      .regc-msg-title {
        font-size: 16px;
        color: #2873ff;
        line-height: 28px;
        font-weight: 700;
        letter-spacing: 1px;
      }
      .regc-title-line {
        display: inline-block;
        width: 24px;
        height: 3px;
        background-color: #2873ff;
        margin-bottom: 8px;
      }
      .regcContent {
        font-size: 12px;
        color: #000000;
        line-height: 26px;
      }
      .regcContent-url {
        font-size: 13px;
        color: #2873ff;
        line-height: 26px;
      }
    }
    .regc-message-bottom {
      .downloadrun {
        .download-btn {
          padding: 8px 20px;
          border-radius: 5px;
          border: 1px solid #2873ff;
          display: inline-block;
          cursor: pointer;
          color: #2873ff;
        }
      }
      .scanrun {
        display: flex;
        justify-content: center;
        .ercode-box {
          display: inline-block;
          width: 90px;
          height: 90px;
          background: #ededed;
        }
        .ercode-box:first-child {
          margin-right: 15px;
        }
      }
    }
  }
}
.container .awards-case div.awards-main {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  padding-left: 100px;
  padding-right: 100px;
  padding-top: 10px;
  padding-bottom: 120px;
  .awards-item {
    padding: 0 30px;
    position: relative;
    margin-top: 40px;
    border-right: 1px solid #dfdfdf;
    display: flex;
    flex-direction: column;
    align-items: center;
    .awards-item-logo {
      width: 36px;
      height: 36px;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center center;
      position: absolute;
      top: -45px;
      left: 50%;
      margin-left: -20px;
    }
    .awards-item-logo1 {
      background-image: url("../../assets/img/jj.png");
    }
    .awards-item-logo2 {
      background-image: url("../../assets/img/jx.png");
    }
    .awards-item-logo3 {
      background-image: url("../../assets/img/zxj.png");
    }
    .awards-item-title {
      font-size: 14px;
      font-weight: 700;
      line-height: 26px;
      color: #000000;
    }
    .awards-item-intr {
      font-size: 12px;
      line-height: 24px;
      color: #000000;
      text-align: center;
    }
  }
  .awards-item:last-child {
    border-right: 0;
  }
}
.contest-date {
  width: 1200px;
  margin: 0 auto;
  padding: 40px 0 30px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  .contest-title {
    font-size: 16px;
    line-height: 36px;
    font-weight: 700;
    margin-bottom: 5px;
  }
  .contest-time {
    line-height: 28px;
    font-size: 12px;
    margin-bottom: 10px;
    color: #2873ff;
  }
  .contest-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    .contest-info-line {
      line-height: 18px;
      color: #9b9e9e;
      font-size: 12px;
    }
  }
  .contest-button {
    margin-top: 35px;
    display: flex;
    justify-content: center;
    align-items: center;
    .contest-button-item {
      display: inline-block;
      padding: 10px 20px;
      background-color: #2873ff;
      color: #ffffff;
      font-size: 14px;
      border-radius: 5px;
      box-shadow: 0 0 1px 0 #f1f1f1;
      cursor: pointer;
    }
    .contest-button-item:first-child {
      margin-right: 40px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/youth/youth.vue